/*  eslint-disable react/display-name */
/*  eslint-disable react/prop-types */

import { languages } from 'countries-list';
import * as R from 'ramda';

const genderMap = {
    M: 'male',
    F: 'female',
    U: 'unspecified',
};

const initGender = {
    '13-17': 0,
    '18-24': 0,
    '25-34': 0,
    '35-44': 0,
    '45-54': 0,
    '55-64': 0,
    '65+': 0,
};

const getInsightsInfo = platformId => {
    switch (platformId) {
        case 3:
            return insights('page_fans');

        case 2:
            return insights('audience');

        default:
            return;
    }
};

const insights = name => ({ demographicTypeName, demographicSegments }) => {
    let data = [];
    switch (demographicTypeName) {
        case `${name}_gender_age`:
            data = demographicSegments.reduce(
                ({ age, gender }, { segmentName, value }) => {
                    const [genderLetter, ageGroup] = segmentName.split('.');

                    const genderName = genderMap[genderLetter];

                    if (age[ageGroup]) {
                        age[ageGroup] += value;
                    } else {
                        age[ageGroup] = value;
                    }
                    return {
                        age,
                        gender: R.assocPath(
                            [genderName, ageGroup],
                            value,
                            gender,
                        ),
                    };
                },
                {
                    age: {},
                    gender: {
                        male: { ...initGender },
                        female: { ...initGender },
                        unspecified: { ...initGender },
                    },
                },
            );

            // [SC-619] remove unspecified gender
            delete data.gender.unspecified;

            return data;

        case `${name}_locale`:
            data = demographicSegments.reduce(
                ({ language }, { segmentName, value }) => {
                    const [iso] = segmentName.split('_');
                    const lang =
                        languages[iso] && languages[iso].name
                            ? languages[iso].name
                            : 'Other';

                    if (language[lang]) {
                        language[lang] += value;
                    } else {
                        language[lang] = value;
                    }

                    return { language };
                },
                { language: {} },
            );
            return data;

        case `${name}_city`:
            data = demographicSegments.reduce(
                ({ cities }, { segmentName: city, value }) => {
                    cities[city] = value;
                    return { cities };
                },
                { cities: {} },
            );
            return data;

        case `${name}_country`:
            data = demographicSegments.reduce(
                ({ countries }, { segmentName, value }) => {
                    const [country] = segmentName.split(',');
                    countries[country] = value;
                    return { countries };
                },
                { countries: {} },
            );
            return data;

        default:
            return null;
    }
};

export default getInsightsInfo;
